import React, {Component} from 'react';
import {Button, FormControl, FormGroup} from 'react-bootstrap';
import {connect} from 'react-redux';
import OverlayLoader from '../components/overlayLoader';
import * as authActions from '../store/auth/authSlice';
import './loginPage.css';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.state = {
      login: '',
      password: ''
    };
  }

  render() {
    return(
      <div>
        <OverlayLoader
          active={this.props.loggedIn}
          text="Authenticating..."
        >
          <div className="authForm">
            <h1>Login</h1>
            <form onSubmit={this.handleFormSubmit}>
              <FormGroup>
                <FormControl
                  autoFocus
                  placeholder="Username"
                  name="login"
                  type="text"
                  onChange={this.handleChange}>
                </FormControl>
              </FormGroup>
              <FormGroup>
                <FormControl
                  placeholder="Password"
                  name="password"
                  type="password"
                  onChange={this.handleChange}>
                </FormControl>
              </FormGroup>
              <Button
                block
                bsStyle="primary"
                disabled={!this.validateForm()}
                type="submit"
              >
                Login
              </Button>
            </form>
            {(this.props.error) ? (<div className="authError text-danger">Error: {this.props.error.toString()}</div>) : null}
          </div>
        </OverlayLoader>
      </div>
    );
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.props.login(this.state.login, this.state.password);
  }

  validateForm() {
    return this.state.login.length > 0 && this.state.password.length > 0;
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.auth.loggedIn,
    error: state.auth.error,
  };
}

const actionCreators = {
  login: authActions.login,
};

export default connect(mapStateToProps, actionCreators)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/loginPage.js